import { Chain } from '@1delta/chain-registry'
import { Lender } from '@1delta/lender-registry'
import {
  compoundV2Pools,
  compoundV2Reserves,
  compoundV2TokenArray,
  compoundV2Tokens,
} from '@1delta/data-sdk'

// needs a legacy lens
export const VENUS_LENS_VBNB = '0xf15A9c5aaDc327B383945D5821C7aC08Cdac7430'

const VENUS_LENS: { [c: string]: string } = {
  [Chain.BNB_SMART_CHAIN_MAINNET]: '0xA179d2f1Fd53D15Bc790bE91d5fF4a0108E29621',
  [Chain.ETHEREUM_MAINNET]: '0x277950603178BDD223eB53B9b7cF5D0053aa3473',
  [Chain.ARBITRUM_ONE]: '0x53F34FF95367B2A4542461a6A63fD321F8da22AD',
  [Chain.BASE]: '0x89825677fb4845f5Fc0B227e387455ECa1200058',
  [Chain.OPBNB_MAINNET]: ' 0x2Ed744F6E722aa5E41E67267774b386D244e5e4e',
  [Chain.OP_MAINNET]: '0x142160A2E699e33af337741f157D96aAd6bC72aA',
  [Chain.UNICHAIN]: '0xe192aeDBDBd235DBF33Ea1444f2B908Ea3E78419',
}

const SUMER_LENS: { [c: string]: string } = {
  [Chain.BNB_SMART_CHAIN_MAINNET]: '0xB7ea94340e65CC68d1274aE483dfBE593fD6f21e',
  [Chain.ETHEREUM_MAINNET]: '0x3375B2EF9C4D2c6434d39BBE5234c5101218500d',
  [Chain.ARBITRUM_ONE]: '0xbdBCf25E9187350b9102E316b707B1B2c7E51492',
  [Chain.BASE]: '0x2B43fBb7D1171bCfA31c9685f24A417dC8757064',
  [Chain.BERACHAIN]: '0x85D682FA4115f6a1Ed91170E705A50D532e3B6BD',
  [Chain.CORE_BLOCKCHAIN_MAINNET]: '0x894fc5177d8e670A4EF4C0aDA2FC5C04861b46Ab',
  [Chain.HEMI_NETWORK]: '0x6f064Eca024f7065b09372FEe1f8a3854843decA',
}

// `MoonwellViews`, per docs.moonwell.fi/moonwell/protocol-information/contracts.
// Ethereum returns the same 23-word `getMarketInfo` payload as Base and OP
// (verified 2026-08-24), so it needs no reader change. The Moonbeam address the
// same page lists (0xe76C8B87…) has NO bytecode on chain 1284, so Moonbeam
// stays unlensed and keeps being dropped.
const MOONWELL_LENS: { [c: string]: string } = {
  [Chain.OP_MAINNET]: '0xD6C66868f937f00604d0FB860241970D6CC2CBfE',
  [Chain.BASE]: '0x6834770aba6c2028f448e3259ddee4bcb879d459',
  [Chain.ETHEREUM_MAINNET]: '0x2d85b9c48a8c582f0AA244e134e9C6f30Cf7786e',
}

const ENCLABS_LENS = {
  [Chain.SONIC_MAINNET]: '0x3567B16050cB90236997eF47B1941502e85d65f3',
  [Chain.PLASMA_MAINNET]: '0xE67B5097b8dC55aCECaB82102A3042078f016550',
}

const TAKARA_LENS = {
  [Chain.SEI_NETWORK]: '0xCe434378adacC51d54312c872113D687Ac19B516',
}

const TECTONIC_LENS = {
  [Chain.CRONOS_MAINNET]: '0x7cc8339110B7d2ae3B856eC667390bD1C9A9E933',
}

// Each Kinetic isolated pool is served by its own Lens (constructor-pinned to a
// single Comptroller), so the three groups have distinct addresses on Flare.
const KINETIC_LENS = {
  [Chain.FLARE_MAINNET]: '0xcB10E547aB931fe12D3df5BF3f2f9D596Ab1A181',
}

const KINETIC_FXRP_LENS = {
  [Chain.FLARE_MAINNET]: '0x553e7b78812D69fA30242E7380417781125C7AC7',
}

const KINETIC_JOULE_LENS = {
  [Chain.FLARE_MAINNET]: '0xB90e2e1bF57F51F8E6c4Cd58a514e69c588e648e',
}

const BENQI_LENS = {
  [Chain.AVALANCHE_C_CHAIN]: '0x15f30De066D21e4828D78A497d31c665a6162D2D',
}

const BENQI_AVALANCHE_ECOSYSTEM_LENS = {
  [Chain.AVALANCHE_C_CHAIN]: '0x2e35184DD4Cd0ED096C6458aAe819a9374802D5D',
}

const LODESTAR_LENS = {
  [Chain.ARBITRUM_ONE]: '0x24C25910aF4068B5F6C3b75252a36c4810849135',
}

const TENDER_LENS = {
  [Chain.ARBITRUM_ONE]: '0x14Ec7324753340Bd8685496da14c4B173ac05b18',
}

const COMPOUND_V2_OG_LENS = {
  [Chain.ETHEREUM_MAINNET]: '0xd513d22422a3062Bd342Ae374b4b9c20E0a9a074',
}
const WE_PIGGY_LENS = {
  [Chain.ETHEREUM_MAINNET]: '0x2910d8cb5A889a22cc88354116DFFb1a3AD8a0E2',
  [Chain.BNB_SMART_CHAIN_MAINNET]: '0x560dD9b47d40E0cd0aEDA326e46BeD25249d936A',
}

const SEGMENT_LENS = {
  [Chain.BNB_SMART_CHAIN_MAINNET]: '0x31e98E70470d06955FB2634f3080ea663646856b',
  [Chain.CORE_BLOCKCHAIN_MAINNET]: '0xb332Ed95E0F90c526cC7720f30e4A76133A8F16a',
}
/** massively robust lens contract  */
const ROBUST_LENS = {
  [Chain.ETHEREUM_MAINNET]: '0x92ee472A52A79AB407aED9FE0deB512d230baF87',
}

/**
 * `CompoundV2MarketLens` — our own deployment, CREATE2'd to ONE address per
 * chain (contracts-delegation `scripts/_shared/deployCompoundV2MarketLens.ts`).
 *
 * Stateless like every CompoundLens, so this single address serves EVERY
 * standard fork on the chain: Base carries Sonne AND Cream, Linea carries Mendi
 * AND Paxo. It exists because no `cTokenMetadata` lens was deployed on these
 * chains at all — not the fork's own, not anyone else's — which is what kept
 * Sonne, Mendi, Iron Bank and the rest unservable.
 *
 * Field order is the canonical 14-word `CTokenMetadata`, so these forks take the
 * ordinary `CreamLensAbi` path with no reader of their own. Verified against the
 * live deployment 2026-08-24: Iron Bank 8/8 on Optimism, Mendi 9/9 and Paxo 4/4
 * on Linea, Sonne 7/7 and Cream 7/7 on Base — every field cross-checked against
 * the market and its comptroller at a pinned block.
 */
const COMPOUND_V2_MARKET_LENS = "0xD16EC79B110f27AA2EEEc913087823Df032121E4"

/**
 * Every chain the lens is deployed on (2026-08-24). One map shared by all the
 * forks it serves rather than nine per-fork copies: the lookup is keyed by
 * chain, and a fork is only ever asked for a chain it has a comptroller on, so
 * listing a chain a given fork does not use costs nothing and keeps the roster
 * in one place. Not yet deployed: Aurora, zkSync Era, Manta, Rootstock, IoTeX,
 * IOTA EVM.
 */
const MARKET_LENS = {
  [Chain.OP_MAINNET]: COMPOUND_V2_MARKET_LENS,
  [Chain.XDC_NETWORK]: COMPOUND_V2_MARKET_LENS,
  [Chain.SEI_NETWORK]: COMPOUND_V2_MARKET_LENS,
  [Chain.MORPH]: COMPOUND_V2_MARKET_LENS,
  [Chain.BASE]: COMPOUND_V2_MARKET_LENS,
  [Chain.AVALANCHE_C_CHAIN]: COMPOUND_V2_MARKET_LENS,
  [Chain.INK]: COMPOUND_V2_MARKET_LENS,
  [Chain.LINEA]: COMPOUND_V2_MARKET_LENS,
  [Chain.BLAST]: COMPOUND_V2_MARKET_LENS,
  [Chain.MANTA_PACIFIC_MAINNET]: COMPOUND_V2_MARKET_LENS,
  /**
   * zkSync Era is the one chain where the address differs. zk-stack chains
   * derive contract addresses from a registered bytecode hash rather than
   * `keccak(0xff ‖ factory ‖ salt ‖ initCodeHash)`, so the CREATE2 factory path
   * is skipped there (see the deploy script) and this is the nonce-derived
   * address of the same runtime — byte-identical to the other nine, verified
   * against the compiled artifact.
   */
  [Chain.ZKSYNC_MAINNET]: '0x6Bc6aCB905c1216B0119C87Bf9E178ce298310FA',
}

const CREAM_LENS = {
  [Chain.ETHEREUM_MAINNET]: '0x92ee472A52A79AB407aED9FE0deB512d230baF87',
  [Chain.BNB_SMART_CHAIN_MAINNET]: '0x1A014Ffe0cd187A298a7E79BA5ab05538686ea4a',
  [Chain.POLYGON_MAINNET]: '0x139Dd8Bb6355d20342e08ff013150b1aE5040a42',
  [Chain.ARBITRUM_ONE]: '0x139Dd8Bb6355d20342e08ff013150b1aE5040a42',
  // Cream's Base deployment has no lens of its own; ours serves it.
  [Chain.BASE]: COMPOUND_V2_MARKET_LENS,
}

const GAMMA_LENS = {
  [Chain.BNB_SMART_CHAIN_MAINNET]: '0xcaf6856f6Ec1B66EE89dD296D2020dfA431D8f6B',
}

/**
 * A CompoundLens is stateless: `cTokenMetadata(cToken)` reads the token and the
 * token's OWN Comptroller, so any lens deployed on a chain serves any standard
 * fork on that chain. These long-tail forks ship no lens of their own and reuse
 * one that is already deployed.
 *
 * WePiggy's BNB lens rather than Cream's: `cTokenMetadata` calls `underlying()`,
 * which reverts on a native market unless the lens recognises its symbol, and
 * Cream's only knows `crBNB` — it reverts on Lander's `rBNB`. WePiggy's returns
 * all 14 fields for every market of all three forks (verified 2026-08-24:
 * Demeter 10/10, Lander 9/9, FilDA 5/5, underlying addresses matching
 * `compound-v2-tokens.json`).
 */
const SHARED_LENS_BNB = {
  [Chain.BNB_SMART_CHAIN_MAINNET]: '0x560dD9b47d40E0cd0aEDA326e46BeD25249d936A',
}


/**
 * Tender's Arbitrum lens, not Cream's: Cream's returns the 22-word variant and
 * Lodestar's a 17-word one, neither of which matches `CreamLensAbi`. Tender's
 * returns the plain 14-field struct for all 7 SolidLizard markets.
 */
const SHARED_LENS_ARBITRUM = {
  [Chain.ARBITRUM_ONE]: '0x14Ec7324753340Bd8685496da14c4B173ac05b18',
}

export const COMPOUND_V2_LENS: {
  [fork: string]: { [chain: string]: string }
} = {
  [Lender.VENUS]: VENUS_LENS,
  [Lender.VENUS_ETH]: VENUS_LENS,
  [Lender.MOONWELL]: MOONWELL_LENS,
  [Lender.ENCLABS]: ENCLABS_LENS,
  [Lender.ENCLABS_LST]: ENCLABS_LENS,
  [Lender.SUMER]: SUMER_LENS,
  [Lender.TAKARA]: TAKARA_LENS,
  [Lender.TECTONIC]: TECTONIC_LENS,
  [Lender.TECTONIC_VENO]: TECTONIC_LENS,
  [Lender.TECTONIC_DEFI]: TECTONIC_LENS,
  [Lender.KINETIC]: KINETIC_LENS,
  [Lender.KINETIC_FXRP]: KINETIC_FXRP_LENS,
  [Lender.KINETIC_JOULE]: KINETIC_JOULE_LENS,
  [Lender.BENQI]: BENQI_LENS,
  [Lender.BENQI_AVALANCHE_ECOSYSTEM]: BENQI_AVALANCHE_ECOSYSTEM_LENS,
  [Lender.LODESTAR]: LODESTAR_LENS,
  [Lender.TENDER]: TENDER_LENS,
  [Lender.COMPOUND_V2]: COMPOUND_V2_OG_LENS,
  [Lender.FLUX_FINANCE]: COMPOUND_V2_OG_LENS,
  [Lender.WE_PIGGY]: WE_PIGGY_LENS,
  [Lender.SEGMENT]: SEGMENT_LENS,
  [Lender.CREAM_FINANCE]: CREAM_LENS,
  [Lender.GAMMA]: GAMMA_LENS,
  [Lender.CAPY_FI]: ROBUST_LENS,
  [Lender.DEMETER]: SHARED_LENS_BNB,
  [Lender.LANDER]: SHARED_LENS_BNB,
  // FilDA also has an IoTeX deployment; it is NOT wired here (no lens on that
  // chain, and all 9 of its IoTeX markets are mint+borrow paused) and is held
  // back by `DISABLED_COMPOUNDS` in `utils/index.ts`.
  [Lender.FILDA]: SHARED_LENS_BNB,
  [Lender.SOLIDLIZARD]: SHARED_LENS_ARBITRUM,
  // Served by our own CompoundV2MarketLens deployment.
  [Lender.IRON_BANK]: MARKET_LENS,
  [Lender.MENDI]: MARKET_LENS,
  [Lender.PAXO]: MARKET_LENS,
  [Lender.SONNE]: MARKET_LENS,
  [Lender.ASO_FINANCE]: MARKET_LENS,
  [Lender.BLUME]: MARKET_LENS,
  [Lender.KAWA]: MARKET_LENS,
  [Lender.XPERT]: MARKET_LENS,
  [Lender.KEOM]: MARKET_LENS,
  [Lender.REACTOR_FUSION]: MARKET_LENS,
}

export function getCompoundV2Comptroller(
  chainId: string,
  lender: string = Lender.VENUS,
): string | undefined {
  return compoundV2Pools()?.[lender]?.[chainId]
}

export function getCompoundV2CollateralTokens(
  chainId: string,
  lender: string = Lender.VENUS,
): { [address: string]: string } {
  return compoundV2Tokens()?.[lender]?.[chainId]
}

export function getCompoundV2Reserves(
  chainId: string,
  lender: string = Lender.VENUS,
): string[] {
  return compoundV2Reserves()?.[lender]?.[chainId]
}

export function getCompoundV2Lens(chainId: string, lender: string) {
  // @ts-ignore
  return COMPOUND_V2_LENS[lender]?.[chainId]
}

export function getCompoundV2Tokens(
  chainId: string,
  lender: string = Lender.VENUS,
): {
  cToken: string
  underlying: string
  /** see `CompoundV2TokenArrayType` — static pause fallback, absent = unknown */
  mintPaused?: boolean
  borrowPaused?: boolean
}[] {
  return compoundV2TokenArray()?.[lender]?.[chainId] ?? []
}
